"use client";

import { schedulePostHogInit } from "../lib/posthog";
import { ReactNode, useEffect } from "react";

interface PostHogProviderProps {
  children: ReactNode;
}

/** Schedules deferred PostHog load; does not import the SDK into the main bundle. */
export function PostHogProvider({ children }: PostHogProviderProps) {
  useEffect(() => {
    return schedulePostHogInit();
  }, []);

  return children;
}
